import React, { useState, useEffect, useRef } from "react";
import MainPlayer from "./MainPlayer";
import EpisodeList from "./EpisodeList";
import { videosList } from "./videosList";
import { Typography, Box, Chip } from "@mui/material";
import OtherTalksSection from "./OtherTalksSection";
import NominateIgniteTalkSection from "./NominateIgniteTalkSection";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import EventIcon from "@mui/icons-material/Event";
import "./IgniteTalksContent.css";

const PLAYER_EPISODE_HEIGHT = 320;

const IgniteVideoContent = () => {
  const [activeTalk, setActiveTalk] = useState(null);
  const [activeEpisode, setActiveEpisode] = useState(null);

  const topRef = useRef(null);

  useEffect(() => {
    const defaultTalk = videosList[0];
    setActiveTalk(defaultTalk);
    setActiveEpisode(null);
  }, []);

  const handleTalkSelect = (talk) => {
    setActiveTalk(talk);
    setActiveEpisode(talk.episodes[0]);

    topRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  if (!activeTalk) return null;

  return (
    <>
      <Box ref={topRef} sx={{ backgroundColor: "#250854", p: 3 }}>
        <Typography
          sx={{
            color: "#fff",
            display: "flex",
            alignItems: "center",
            mb: 1,
          }}
        >
          <FiberManualRecordIcon sx={{ color: "#F9F506", width: 10, mr: 1 }} />
          Most Recent Ignite Talks
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "2.5fr 1.5fr",
            gap: 6,
            mb: 3,
          }}
          className="ignite-talks-firstwrap"
        >
          <Box>
            <Typography
              sx={{ color: "#fff" }}
              className="active-talk-title"
            >
              {activeTalk.title}
            </Typography>

            <Chip
              label={activeTalk.category}
              sx={{
                backgroundColor: "#EEE6FF",
                color: "#250854",
                fontWeight: 600,
                mt: 1,
                borderRadius: 0,
              }}
            />

            <Box
              sx={{
                display: "flex",
                gap: 3,
                color: "#ddd",
                fontSize: 13,
                mt: 2,
              }}
              className="ignite-talks-timings-box"
            >
              <Box sx={{ display: "flex", gap: 0.5 }}>
                <AccessTimeIcon sx={{ fontSize: 16 }} />
                {activeTalk.duration}
              </Box>

              <Box sx={{ display: "flex", gap: 0.5 }}>
                <VideoLibraryIcon sx={{ fontSize: 16 }} />
                {activeTalk.episodes.length} Recordings
              </Box>

              <Box sx={{ display: "flex", gap: 0.5 }}>
                <EventIcon sx={{ fontSize: 16 }} />
                {activeTalk.courseDate}
              </Box>
            </Box>
          </Box>

          <Box sx={{ color: "#ddd", maxWidth: 520, position: "relative" }}>
            <Box
              component="img"
              src={activeTalk.speakerImage}
              alt={activeTalk.speakerName}
              sx={{
                width: 60,
                height: 60,
                borderRadius: "50%",
                objectFit: "cover",
                position: "absolute",
                left: -75,
              }}
              className="ignite-talks-speakerimg"
            />

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 1,
              }}
              className="ignite-talks-speaker-textbox"
            >
              <Typography sx={{ fontSize: 13, opacity: 0.9 }}>
                Speaker of the session:
              </Typography>

              {/* <Box
                component="img"
                src={activeTalk.speakerImage}
                alt={activeTalk.speakerName}
                sx={{
                  width: 22,
                  height: 22,
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              /> */}

              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: 14,
                }}
              >
                {activeTalk.speakerName}
              </Typography>
            </Box>

            <Typography
              sx={{
                fontSize: 12,
                lineHeight: 1.7,
                color: "#E0D7FF",
              }}
            >
              {activeTalk.courseDescription}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{ display: "flex", gap: 2 }}
          className="ignite-talks-videos-box"
        >
          <Box sx={{ flex: 2.4, height: PLAYER_EPISODE_HEIGHT }}>
            <MainPlayer
              video={{
                url: activeEpisode?.url,
                thumbnail: activeEpisode
                  ? activeEpisode.thumbnail
                  : activeTalk.thumbnail,
              }}
              isVideoSelected={!!activeEpisode}
              onPlayClick={() => {
                if (!activeEpisode && activeTalk.episodes.length) {
                  setActiveEpisode(activeTalk.episodes[0]);
                }
              }}
            />
          </Box>

          <Box
            sx={{ flex: 2, height: PLAYER_EPISODE_HEIGHT }}
            className="ignite-talks-seprate-videos-box"
          >
            <EpisodeList
              episodes={activeTalk.episodes}
              activeEpisode={activeEpisode}
              onSelect={setActiveEpisode}
            />
          </Box>
        </Box>
      </Box>

      <OtherTalksSection
        talks={videosList}
        activeTalkId={activeTalk.id}
        onSelectTalk={handleTalkSelect}
      />

      <NominateIgniteTalkSection />
    </>
  );
};

export default IgniteVideoContent;
